var _defs, _path, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamMembers(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 944.799,
    height: 923.194,
    viewBox: "0 0 944.799 923.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.571,
    y1: 1.795,
    x2: 0.493,
    y2: 0.379,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1.147,
    x2: 0.5,
    y2: 0.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 2.165,
    x2: 0.5,
    y2: 0.322,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M385.451,96.012C565.86-32.17,698.992-32.435,748.789,97.808S636.273,481.779,530.766,589.4s-247.9,147.522-353.743,131.648S-33.812,635.018,10.35,549.411,117.5,452.268,215.634,372.368,205.042,224.194,385.451,96.012Z",
    transform: "translate(223.851) rotate(18)",
    fill: "#ffdc9c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(-27.806 -1686.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(292 1896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    d: "M58.669,0H171.4a58.67,58.67,0,0,1,58.67,58.67V171.4a58.67,58.67,0,0,1-58.67,58.67H58.67A58.67,58.67,0,0,1,0,171.4V58.669A58.669,58.669,0,0,1,58.669,0Z",
    transform: "translate(0 114.611)",
    opacity: 0.95,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 106.519,
    height: 5.262,
    transform: "translate(61.776 292.302)",
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 76.345,
    height: 5.262,
    transform: "translate(76.863 308.883)",
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    d: "M69.116,0H245.762a69.115,69.115,0,0,1,69.115,69.115V300.479a69.115,69.115,0,0,1-69.115,69.115H69.115A69.115,69.115,0,0,1,0,300.479V69.116A69.116,69.116,0,0,1,69.116,0Z",
    transform: "translate(267.919 194.405)",
    opacity: 0.95,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(410.688 412.443)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 24.974,
    height: 4.625,
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(315.874 454.825)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 145.319,
    height: 8.955,
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 117.513,
    height: 8.955,
    transform: "translate(0 42.993)",
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 68.891,
    height: 8.955,
    transform: "translate(0 21.496)",
    fill: "#96bfe6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(318.376 231.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M2170.728,763.9v4.523h26.63v24.992h4.522V763.9Zm-180.836,29.515h4.522V768.425h26.629V763.9h-31.152Zm207.465,128.961v25h-26.63V951.9h31.152V922.378Zm-202.943,0h-4.522V951.9h31.152v-4.523h-26.629Z",
    transform: "translate(-1989.892 -763.902)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(489.633 454.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M2409.152,1328.2a26.632,26.632,0,1,1,26.632-26.632A26.662,26.662,0,0,1,2409.152,1328.2Zm0-48.109a21.477,21.477,0,1,0,21.477,21.477A21.5,21.5,0,0,0,2409.152,1280.094Z",
    transform: "translate(-2382.521 -1274.94)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(12.834 17.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M2424.043,1335.285l-12.1-12.1,3.645-3.645,8.454,8.454,11.851-11.851,3.646,3.644Z",
    transform: "translate(-2411.945 -1316.144)",
    fill: "#4598e6"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 155.075,
    height: 133.054,
    transform: "translate(37.498 123.214)",
    opacity: 0.95,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 169.033,
    height: 152.236,
    rx: 48.233,
    transform: "translate(252.67 29.412)",
    opacity: 0.95,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(329.842 152.855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 13.406,
    height: 2.483,
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(280.286 56.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M1999.644,364.3v2.428h14.295v13.417h2.428V364.3Zm-97.077,15.844h2.428V366.725h14.3V364.3h-16.723Zm111.371,69.229v13.421h-14.295v2.428h16.723V449.37Zm-108.944,0h-2.428v15.85h16.723v-2.428h-14.3Z",
    transform: "translate(-1902.567 -364.297)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(106.082 266.595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 17.906,
    height: 3.317,
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(39.034 138.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M1479.132,551.257V554.5h19.094V572.42h3.242V551.257ZM1349.467,572.42h3.243V554.5H1371.8v-3.242h-22.337Zm148.759,92.469v17.927h-19.094v3.243h22.337v-21.17Zm-145.517,0h-3.243v21.17H1371.8v-3.243h-19.095Z",
    transform: "translate(-1349.467 -551.257)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(320.261 150.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(0 102.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M2194.4,932.335h-29.872c-1.965-14.3-4.381-30.629-4.381-30.629s-1.208,13.474-2.676,30.629H2037.937c-1.09-15.427-2.4-26.971-2.877-27.208-.687-.343-4.949,13.344-8.49,27.208h-32.358c8.323-35.851,23.845-93.368,32.82-96.814,12.775-4.914,64.871-20.968,64.871-20.968h29.729s52.829,15.072,57.743,31.458C2183.282,859.071,2191.9,902.132,2194.4,932.335Z",
    transform: "translate(-1994.213 -814.553)",
    fill: "#e65353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(80.702 6.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M2212.451,593.1s27.759,4.373,23.532,47.806-28.728,39.873-30.365,39.829-24.6.792-26.385-52.237C2179.233,628.5,2178.452,589.288,2212.451,593.1Z",
    transform: "translate(-2179.232 -592.842)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(89.913 76.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M2237.315,758.94s-.761,17.864.968,21.732-22.908,16.289-37.934,2.446c0,0,3.629-19.414,2.619-26.3S2237.315,758.94,2237.315,758.94Z",
    transform: "translate(-2200.349 -754.23)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(136.27 40.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M2308.243,673.066s3.041-3.247,4.154.04-4.716,17.975-4.334,18.634c0,0-.555,1.275-1.285.573S2308.243,673.066,2308.243,673.066Z",
    transform: "translate(-2306.629 -671.635)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(76.697 40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M2174.371,671.743s-2.977-3.305-4.155-.04,4.368,18.062,3.975,18.714c0,0,.53,1.285,1.273.6S2174.371,671.743,2174.371,671.743Z",
    transform: "translate(-2170.051 -670.262)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(77.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M2232.258,627.249l-3.974,5.313s.112-11.648-.526-13.475-1.613-7.406-2.146-8.722-23.839-7.846-44.424,1.907c0,0,.9,8.376-1.068,9.121s-1.006,13.642-1.006,13.642l-3.268-3.687s-5-33.416-3.767-36.9,5.171-24.422,47.4-11.992c0,0,13.166-2.789,15.809,6.3S2232.258,627.249,2232.258,627.249Z",
    transform: "translate(-2171.884 -578.557)",
    fill: "#d98b52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(89.899 102.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M2238.265,814.677s6.263,1.337-19.947,26.454c0,0-18.59-20.564-17.987-24.008S2238.265,814.677,2238.265,814.677Z",
    transform: "translate(-2200.316 -814.542)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(107.9 99.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M2241.587,836.457l7.153,12.231,21.217-36.025-9.188-6.409Z",
    transform: "translate(-2241.587 -806.254)",
    fill: "#b84343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(80.702 101.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M2206.431,839.8l-17.358-27.619-9.84,6.324,17.643,33.526Z",
    transform: "translate(-2179.232 -812.179)",
    fill: "#b84343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(101.309 129.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M2227.688,951.889c.213,4.073.308,9.069.32,14.681h-.983c-.012-5.588-.106-10.573-.32-14.634-1.61-30.641,5.813-67.924,5.861-76.662l.959.19C2233.477,884.2,2226.078,921.378,2227.688,951.889Z",
    transform: "translate(-2226.476 -875.274)",
    fill: "#b84343"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M2212.281,781.328s6.594,6.973,15.911,5.114,13.453-6.125,13.453-6.125a17.316,17.316,0,0,1-14.448,10.067C2216.426,791.228,2212.281,781.328,2212.281,781.328Z",
    transform: "translate(-2117.164 -692.313)",
    fill: "#c78d71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(43.443 92.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(46.083 31.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M1469.43,533.354a.287.287,0,0,1-.063-.007c-.627-.152-1.619-3.155-1.812-3.755-.045-.165-.143-.467-.278-.885-.778-2.4-2.6-8.032-1.889-10.189.223-.68.573-1.074,1.038-1.171,1-.206,2.135,1.059,2.183,1.113l.024.027,0,.037c.259,2.367,1.522,14.207.977,14.751A.26.26,0,0,1,1469.43,533.354Zm-2.774-15.8a.929.929,0,0,0-.183.018c-.379.079-.67.421-.866,1.019-.687,2.085,1.184,7.87,1.889,10.047.136.421.234.725.28.89.461,1.438,1.277,3.509,1.646,3.6.009,0,.017,0,.033-.012.347-.47-.451-9.143-1.039-14.527A3.111,3.111,0,0,0,1466.656,517.553Z",
    transform: "translate(-1465.228 -517.324)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(38.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M1480.6,445.792s15.281-1.6,20.786,13.156,10.69,19.588,11.34,27.34c2.625,31.355,17.267,24.263,13.149,42.337s-6.97,20.809-6.97,20.809L1483.9,542.57l-35.462.114s13.874-6.929,10.785-21.686-10.785-38.943-6.438-55.417S1471.465,447.051,1480.6,445.792Z",
    transform: "translate(-1448.433 -445.741)",
    fill: "#16202e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(89.264 31.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M1564.544,533.354a.261.261,0,0,1-.186-.08c-.545-.544.719-12.384.977-14.751l0-.037.024-.027c.048-.054,1.187-1.322,2.184-1.113.465.1.813.49,1.038,1.171.71,2.157-1.111,7.786-1.889,10.19-.135.418-.232.72-.276.88-.194.6-1.186,3.608-1.813,3.76A.275.275,0,0,1,1564.544,533.354Zm1.015-14.769c-.588,5.384-1.386,14.057-1.036,14.529.014.014.022.012.03.01.369-.089,1.185-2.161,1.648-3.6.044-.16.143-.464.278-.885.7-2.177,2.575-7.962,1.89-10.047-.2-.6-.489-.94-.867-1.019C1566.706,517.406,1565.725,518.408,1565.559,518.585Z",
    transform: "translate(-1564.224 -517.323)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(0 79.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M1502.346,689.147h-21.814c-4.523-8.243-8.2-14.691-8.2-14.691a65.907,65.907,0,0,0-5.221,14.691H1393.68a63.427,63.427,0,0,1-.955-15.366s-3.925,7.092-8.478,15.366h-24.67c6.547-12.259,18.813-34.581,21.6-37.49,3.5-3.667,23.791-17.692,38.278-22.268s22.731-.159,22.731-.159a171.673,171.673,0,0,1,28.64,8.137C1476.236,639.511,1491.178,667.106,1502.346,689.147Z",
    transform: "translate(-1359.576 -627.313)",
    fill: "#faa146"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(48.828 8.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M1495.629,465.432s20.238,2.92,17.275,32.8-20.824,27.5-22.016,27.479-17.919.621-19.366-35.833C1471.522,489.873,1470.847,462.915,1495.629,465.432Z",
    transform: "translate(-1471.52 -465.266)",
    fill: "#8e4f3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(58.886 62.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M1517.621,589.93s-1.253,15.54,1.74,20.2-2.56,10.975-14,8.814-10.776-8.647-10.776-8.647,3.2-9.59,2.267-17.266S1517.621,589.93,1517.621,589.93Z",
    transform: "translate(-1494.578 -588.574)",
    fill: "#8e4f3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(46.816 3.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M1490.714,470.153s9.456,9.941,13.848,14.974,4.9,14.757,4.9,14.757,7.4-9.037,4.3-19.561-10.415-31-28.947-24.709-19.219,33.975-17.045,47.7C1467.773,503.316,1476.091,473.012,1490.714,470.153Z",
    transform: "translate(-1466.909 -454.436)",
    fill: "#16202e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(56.008 79.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M1521.007,631.18s-14.035,35.547-22.565,41.724c0,0-11.205-36.254-10.422-41.562C1488.019,631.342,1504.922,624.719,1521.007,631.18Z",
    transform: "translate(-1487.98 -628.35)",
    fill: "#8e4f3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(39.773 73.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M1470.363,615.131s-25.019,22.261-18.526,36.149c5.542,11.853,25.191,4.584,21.95-7.836S1470.363,615.131,1470.363,615.131Z",
    transform: "translate(-1450.76 -615.131)",
    fill: "#16202e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(62.647 65.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M1503.2,598.215a17.678,17.678,0,0,0,17.016-1.945,10.949,10.949,0,0,1-8.508,5.5C1505.533,602.453,1503.2,598.215,1503.2,598.215Z",
    transform: "translate(-1503.202 -596.27)",
    fill: "#633029"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(295.201 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(0 77.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M1969.714,412.207s-8.3,31.228-10.029,38.264a58.513,58.513,0,0,1-4.291,9.962c-.015.03-.03.06-.052.1a7.952,7.952,0,0,0-.776,2.537c-.335,2.6.665,4.656-1.066,7.745l-.313,1.3h-16.424c1.917-5.693,4.35-12.939,6.3-18.774,1.634-4.925,2.925-8.843,3.269-9.977,1.014-3.387,4.739-14.357,7.9-21.639,1.1-2.537,5.357-5.044,9.125-6.858C1966.728,413.259,1969.714,412.207,1969.714,412.207Z",
    transform: "translate(-1936.762 -412.207)",
    fill: "#323657"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(21.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M1986.617,266.957s-5.236-33.869,22.815-33.244,27.676,17.372,27.176,33.994-11.248,15.372.875,38.493-10.5,23.121-10.5,23.121L2009.432,305.2Z",
    transform: "translate(-1986.23 -233.704)",
    fill: "#fccca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(21.901 2.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M2006.783,240.664s-19,3-19.747,29.994,5.124,32.745,21.747,27.121,21.87-33.869,22.246-38.243S2032.4,237.414,2006.783,240.664Z",
    transform: "translate(-1986.973 -240.269)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(4.324 68.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M2017.424,419.842c.067,9.29-10.61,31.512-12.26,38.376-.194.8-.4,1.537-.612,2.231h-51.844c-.268-3.2-.522-5.939-.649-7.484-.411-5.074-5.551-16.006-5.38-21.095.179-5.186,2.724-9.663,6.283-15.2,1.1-1.716,2.268-3.462,3.425-5.164,3.776-5.537,7.543-10.566,9.394-12.3a30.14,30.14,0,0,1,3.783-3.015l.008-.007a17.469,17.469,0,0,1,3.895-2.052l16.326-2.612s10.178,3.687,16.035,5.051C2005.828,396.575,2017.252,398.247,2017.424,419.842Z",
    transform: "translate(-1946.674 -391.524)",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(9.025 73.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M1975.651,402.216l-9.464,14.915-8.735,13.766c.02-.074.6-2.158,1.589-8.195.188-1.146.389-2.435.6-3.878a10.244,10.244,0,0,1,.275-1.27h0c3.738-8.619,15.3-15.117,15.719-15.333Z",
    transform: "translate(-1957.452 -402.216)",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(29.984 47.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M2029.917,343.726c-1.647,3.11-3.386,22.412-3.386,22.412s-23.235,8.782-20.857,3.814a18.984,18.984,0,0,0,1.417-7.7,37.309,37.309,0,0,0-.258-4.689c-.06-.508-.107-.8-.107-.8S2031.563,340.615,2029.917,343.726Z",
    transform: "translate(-2005.503 -343.328)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(21.964 2.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M1999.115,259.446s9.749,15.873,18.621,22.121,4.375,11.248,4.375,11.248,23.153-48.742,1.141-52.116-35.51-3.624-36.135,29.37C1987.117,270.07,1997.115,259.2,1999.115,259.446Z",
    transform: "translate(-1987.117 -239.225)",
    fill: "#fccca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(31.314 60.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M2021.8,371.4c-3.566,5.261-12.99,6.677-12.99,6.677h0a37.332,37.332,0,0,0-.257-4.689C2014.608,374.557,2021.8,371.4,2021.8,371.4Z",
    transform: "translate(-2008.554 -371.402)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M1962.015,417.459h0s-.5,1.045-.918,5.25l3.422-5.165s6.113-8.763,8.207-11.042a34.781,34.781,0,0,1,4.97-4.275S1965.669,408.006,1962.015,417.459Z",
    transform: "translate(-1950.481 -328.721)",
    fill: "#ebeeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M2062.354,431.19s14.913-5.849,19.325-6.189c0,0-3-23.947-17.648-21.41S2062.354,431.19,2062.354,431.19Z",
    transform: "translate(-2004.586 -329.383)",
    fill: "#e55353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M1997.746,394.069S1986.8,410.9,1990.5,412.375s23.768-1.963,32.3-17.953C2022.8,394.421,2010.047,387.882,1997.746,394.069Z",
    transform: "translate(-1966.631 -322.621)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M2062.73,419.733c-.76,13.2-4.506,25.721-7.6,37.212-.448,1.664-.881,3.313-1.284,4.932h-30.362c-.074-4.552-.06-8.566.082-11.916,1.53-36.638,13.14-55.9,13.14-55.9s3.708,1.246,14.379,4.268c7.313,2.067,10.073,11.372,11.08,17.013a.474.474,0,0,1,.015.067A40.211,40.211,0,0,1,2062.73,419.733Z",
    transform: "translate(-1985.635 -324.114)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M1972.948,397.529a87.805,87.805,0,0,0-4.514,9.059c-3.6,8.246-8.089,21.3-8.469,35.69a209.924,209.924,0,0,1-2.432,21.557h-6.059a96.211,96.211,0,0,0-3.336-18.774c-.828-2.948-1.589-5.149-2-6.544-1.932-6.574,4.246-15.327,6.313-18.46S1959.479,402.543,1972.948,397.529Z",
    transform: "translate(-1941.84 -326.072)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M2090.4,466.793h-16.3a21.6,21.6,0,0,0-.963-4.932c-2.962-10.529-11.729-31.026-11.729-31.026s-13.118-21.437-.687-26.9,17.781,9.8,19.453,16.319a.5.5,0,0,1,.015.067C2080.591,421.881,2087.994,450.1,2090.4,466.793Z",
    transform: "translate(-2003.63 -329.03)",
    fill: "#323657"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMembers);
export default __webpack_public_path__ + "static/media/TeamMembers.0858b858756afb9f71df35351371c058.svg";
export { ForwardRef as ReactComponent };